import FeatureFlagListItem from './FeatureFlagsListItem';
import { observer } from 'mobx-react';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { isFeatureEnabled } from 'owa-feature-flags';
import featureDefinitions from 'owa-feature-flags/lib/store/featureDefinitions';
import * as React from 'react';
/* tslint:disable:forbid-import */
import { action, observable } from 'mobx';
/* tslint:enable:forbid-import */

const styles = require('./FeatureFlagsList.scss');
@observer
export default class FeatureFlagsList extends React.Component<{}, {}> {
    @observable filterText: string;

    render() {
        return (
            <div className={styles.outerContainer}>
                <div className={styles.searchBoxContainer}>
                    <SearchBox
                        labelText="Filter feature flags"
                        onChanged={this.onFilterTextChanged.bind(this)}
                    />
                </div>
                <div className={styles.flagList}>
                    {[...Object.keys(featureDefinitions)]
                        .sort()
                        .filter(
                            (key: string) =>
                                !this.filterText ||
                                key.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
                        )
                        .map(key => (
                            <FeatureFlagListItem
                                name={key}
                                key={key}
                                isOn={isFeatureEnabled(key as any)}
                            />
                        ))}
                </div>
            </div>
        );
    }

    @action
    private onFilterTextChanged(filterText: string) {
        this.filterText = filterText;
    }
}
